import React from 'react';
import {FormControl, IconButton, InputAdornment, InputLabel, OutlinedInput} from "@mui/material";
import PropTypes from "prop-types";
import {makeStyles} from "@mui/styles";
import VisibilityIcon from "@mui/icons-material/Visibility";
import VisibilityOffIcon from "@mui/icons-material/VisibilityOff";

const useStyles = makeStyles((theme) => ({
    root: {
        width: '100%', // Fix IE 11 issue.
    },
    icon: {
        color: theme.palette.text.secondary,
    }
}));

export default function PasswordTextField(props) {
    const classes = useStyles();
    const {label, value, onChange, ...other} = props;
    const [inputValue, setInputValue] = React.useState(value);
    const [showPassword, setShowPassword] = React.useState(false);

    const handleChange = (event) => {
        setInputValue(event.target.value);
        if (onChange) onChange(event);
    }

    const handleClickShowPassword = () => {
        setShowPassword(!showPassword);
    };

    const handleMouseDownPassword = (event) => {
        event.preventDefault();
    };

    return (
        <FormControl variant="outlined" className={classes.root}>
            <InputLabel color="secondary"
                        htmlFor="outlined-adornment-password">{label} *</InputLabel>
            <OutlinedInput
                {...other}
                color="secondary"
                type={showPassword ? 'text' : 'password'}
                required
                fullWidth
                value={inputValue}
                onChange={handleChange}
                endAdornment={
                    <InputAdornment position="end">
                        <IconButton
                            aria-label="toggle password visibility"
                            onClick={handleClickShowPassword}
                            onMouseDown={handleMouseDownPassword}
                            edge="end"
                            className={classes.icon}
                        >
                            {showPassword ? <VisibilityIcon/> : <VisibilityOffIcon/>}
                        </IconButton>
                    </InputAdornment>
                }
                label={label}
            />
        </FormControl>
    );
}

PasswordTextField.propTypes = {
    value: PropTypes.string.isRequired,
    onChange: PropTypes.func.isRequired,
    label: PropTypes.string
}

PasswordTextField.defaultProps = {
    value: "",
    onChange: null,
    label: "Password"
}